import { Route, Routes } from 'react-router-dom';

import { FormWrapper, HeaderAndFormWrapper, Main, PageWrapper } from './index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import LoginEmail from './email';
import LoginMain from './main';
import LoginTwoStepEmail from './two_step_email';

export default function LoginPage() {
  return (
    <PageWrapper>
      <HeaderAndFormWrapper>
        <Header />
        <FormWrapper>
          <Main>
            <Heading align="center">Login</Heading>
            <Routes>
              <Route path="" element={<LoginMain />} />
              <Route path="email" element={<LoginEmail />} />
              <Route path="two_step_email/*" element={<LoginTwoStepEmail />} />
            </Routes>
          </Main>
        </FormWrapper>
      </HeaderAndFormWrapper>
      <Footer />
    </PageWrapper>
  );
}
